export default __webpack_public_path__ + "static/media/undraw_Data_trends_re_2cdy.66575768.png";